/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_Scenario_B1Inputs */

const en_pol_scenario_b1 = /** @type {(inputs: Pol_Scenario_B1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription login stored by Bystep`)
};

const id_pol_scenario_b1 = /** @type {(inputs: Pol_Scenario_B1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login langganan disimpan di Bystep`)
};

/**
* | output |
* | --- |
* | "Subscription login stored by Bystep" |
*
* @param {Pol_Scenario_B1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_scenario_b1 = /** @type {((inputs?: Pol_Scenario_B1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Scenario_B1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_scenario_b1(inputs)
	return en_pol_scenario_b1(inputs)
});